import './index.scss'

class Hero {
    constructor(el) {
        this.$el = el
    }
    init() {}
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.acf-hero') ].forEach($block => {
        $block.expandygg = new Hero($block)
    })
}, {capture: false, passive: true, once: true} || false)